export default __webpack_public_path__ + "static/media/auxilioalimentacao.330e3d3d.png";